import { IntegrationType } from './Integration.js';

class IntegrationMapper {
  static getAllInboundIntegrationsModelFromResponse(data) {
    return Object.values(data).map(_ref => {
      let {
        name,
        alias,
        integrationType,
        hidden
      } = _ref;
      return {
        name,
        alias,
        type: IntegrationType[integrationType],
        hidden,
        rank: 0,
        isMarketplace: false,
        logo: '',
        isConnected: false,
        hideIntegrationCard: false
      };
    });
  }
}

export { IntegrationMapper };
//# sourceMappingURL=IntegrationMapper.js.map
